/* ============================================================
   VEYLA | listicle E  ·  WHERE THIS PAGE SENDS PEOPLE, AND WHAT IT COSTS THERE

   Omar's instruction, 2026-08-12: every CTA on this lander goes to the CLIENT'S
   OWN product page, /products/growth-serum, not to the v2 product we built our
   PDP on.

   That is a routing decision with an arithmetic consequence, which is the whole
   reason this file exists.

   THE LEDGER DOES SUMS. It tells a reader that the money she was about to spend
   on a transplant buys her N years of cover "on the current offer". Until today
   those sums ran on ../../shared/vy-offer.js, which is the ladder of the
   product WE control: bundle variants, a dedicated Seal plan, $17.49 a tube at
   the four-tube size. None of that exists on the page she now lands on. Left
   alone, the page would have quoted seventeen years of cover against an offer
   the destination does not sell, which is the same class of fault as omar-os
   #883 and breaks rule 4 of PDP-SOT: no number is advertised that the cart will
   not honour.

   So the destination is described here, from the destination itself, and the
   engine prices against this rather than against our ladder.

   READ OFF THE LIVE STORE 2026-08-12 via /products/growth-serum.js:

     product      Veyla™ Hair Growth Serum, id 10896017424551
     variant      50715117191335, the only one. There are no bundle variants on
                  this product: its multi-tube offers come from the Kaching
                  Bundles app, which prices in the cart rather than on the
                  variant, so there is no honest way to read a bundle price out
                  of it from here.
     price        4995 one time
     compare at   7995, the list price the store itself publishes per tube
     plan         a "Subscribe & save" group exists on it

   WHICH NUMBER THE COVER IS WORKED OUT ON, AND WHY IT IS THE DEAR ONE.

   basisCents is the ONE TIME single tube price, 4995. Not the subscribed price,
   not a bundle. It is the most expensive way to buy on that page, so every
   figure the ledger prints is the LEAST her money buys there. She cannot arrive
   and find she was told more cover than the page sells, and the fine print says
   larger sizes cover longer, which is true and is the direction that helps her.

   The old basis was $17.49 a tube and printed seventeen years; this one prints
   six. That drop is not a regression. It is the number that survives contact
   with the page the button now opens.

   WHEN THIS GOES STALE. If the client reprices growth-serum, every figure in
   the ledger is wrong until this file is corrected and the lander is rebuilt
   and repushed. Re-probe with:

       curl -s https://tryveyla.com/products/growth-serum.js

   and check `variants[0].price` and `compare_at_price` against the two numbers
   below. Nothing else on the page needs touching.
   ============================================================ */
(() => {
  window.VS_DEST = {
    /* Path rather than the absolute URL Omar sent, so the link stays on
       whatever domain the page is being served from. */
    url: '/products/growth-serum',

    productId: 10896017424551,
    variantId: 50715117191335,

    /* Probed 2026-08-12. See the header before changing either. */
    basisCents:   4995,   /* one tube, one time, the dearest way to buy */
    compareCents: 7995,   /* the per tube list price the store publishes */
    probedOn:     '2026-08-12',

    /* One tube is four weeks of cover, the same figure every other Veyla
       surface uses. Stated here because the ledger's arithmetic is now wholly
       about this product. */
    weeksPerTube: 4
  };
})();
